import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBatteryLow"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5V19H20V16H23V8H20V5H1ZM20 9.5V14.5H21.5V9.5H20ZM5.25 9H6.75V15H5.25V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryLow;
